import React, { Component } from "react";
import Select from "react-select";
import axios from "axios";
import { api } from "../utils/Api";

export default class PsiPicker2 extends Component {
	constructor(props) {
		super(props);

		this.state = {
			psis: [],
			value: null, // use null instead of undefined for react-select
			isClearable: true,
			isSearchable: true,
		};
	}

	getPsi = async () => {
		const url = api + `/psi/list/${this.props.franchise}/${this.props.plant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			this.setState({
				psis: data
					.filter((i) => i.active)
					.map((pressure) => {
						return {
							value: pressure._id,
							label: pressure.psi,
							minPrice: pressure.minPrice || 0,
							price: pressure.cogsPrice || 0,
						};
					}),
			});
		} catch (err) {
			console.error(err.message);
			this.setState({ psis: [] });
		}
	};

	componentDidUpdate(prevProps) {
		if (this.props.plant !== prevProps.plant) {
			if (this.props.isDisabled === false) {
				this.setState({ psis: [], value: null }, () => this.getPsi());
			} else {
				this.setState({ psis: [], value: null });
			}
		}
		if (this.props.franchise !== prevProps.franchise) {
			if (this.props.isDisabled === false) {
				this.setState({ psis: [], value: null }, () => this.getPsi());
			} else {
				this.setState({ psis: [], value: null });
			}
		}
	}

	onChange = (psi) => {
		this.props.action(psi);
		this.setState({ value: psi });
	};

	render() {
		return (
			<div>
				<Select
					name="form-field-name"
					placeholder="Psi..."
					value={this.state.value}
					onChange={this.onChange}
					isClearable={this.state.isClearable}
					isSearchable={this.state.isSearchable}
					options={this.state.psis}
					isDisabled={this.props.isDisabled}
				/>
			</div>
		);
	}
}
